<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
    };
  }
};
</script>
